import { render, staticRenderFns } from "./SummaryTagsAssign.vue?vue&type=template&id=2d3ea9ac&scoped=true&"
import script from "./SummaryTagsAssign.vue?vue&type=script&lang=js&"
export * from "./SummaryTagsAssign.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTagsAssign.vue?vue&type=style&index=0&id=2d3ea9ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ea9ac",
  null
  
)

export default component.exports